var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 179.884,
    height: 77.393,
    viewBox: "0 0 179.884 77.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-95.558 -8.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M152.808,37.895c-.311,0-.62.008-.927.024a18.339,18.339,0,0,0-14.374-13.555L147.878,14.2l-6.131-6.13L126.228,23.5H97.355v7.61h21.22L104.33,45.275l-.211.211h12l.152.727,0,.007h.006A18.332,18.332,0,0,0,124,57.545,10.251,10.251,0,1,1,104.066,53.1H95.823a18.282,18.282,0,0,0,35.8,7.347,18.362,18.362,0,0,0,2.515.177c.311,0,.62-.008.927-.023a18.285,18.285,0,1,0,17.744-22.7ZM134.1,52.885A10.515,10.515,0,1,1,144.61,42.37,10.516,10.516,0,0,1,134.1,52.885Zm18.713,13.549a10.268,10.268,0,0,1-10-8,18.346,18.346,0,0,0,9.254-12.472c.246-.018.5-.03.747-.03a10.253,10.253,0,0,1,0,20.505Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(174.78 37.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M300.671,79.939a13.38,13.38,0,0,1,4.418.578c2.261.788,4.839,3.208,4.839,8.572a12.829,12.829,0,0,1-.053,1.42c-.052.736-.21,4.944-3.471,6.363a6.61,6.61,0,0,1-1.157.315,5.571,5.571,0,0,1,2.84,1.1c1.42,1.052,2.787,3.471,2.787,7.573a13.73,13.73,0,0,1-2.314,8.1,7.634,7.634,0,0,1-3,2.367c-1.473.631-3,.788-6.1.841H288.68V79.939Zm-5.259,15.2H298.2a7.574,7.574,0,0,0,2.367-.263c1.525-.578,2.472-2,2.472-5.154,0-1.683-.315-3.681-2.051-4.365a5.406,5.406,0,0,0-2.209-.316h-3.366Zm.053,16.83h3.366a6.014,6.014,0,0,0,2.734-.473c1.315-.684,2.209-2.367,2.209-5.417,0-3.366-.894-4.944-2.577-5.575a6,6,0,0,0-2.366-.315h-3.366Z",
    transform: "translate(-288.68 -79.939)",
    fill: "#2f80c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M353.62,102.5l3.734,24.4,3.787-24.4h6.574l-6.785,30.24c-.894,3.787-1.472,5.89-2.945,7.153-1.21,1.1-3,1.209-4.576,1.262h-4.733l.052-5.048h2.787a2.151,2.151,0,0,0,1.735-.526,1.562,1.562,0,0,0,.421-1.052,3.567,3.567,0,0,0-.105-.736L346.888,102.5Z",
    transform: "translate(-323.01 -93.246)",
    fill: "#2f80c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M409.217,83.913v7.626h2.84v4.681h-2.787v16.513a3.821,3.821,0,0,0,.158,1.368c.421.841,1.683.683,2.682.683l-.052,5.049c-1,0-2,.052-3,0-.263,0-3.313.1-4.786-1.052-1.367-1.052-1.42-2.787-1.525-4.1V96.219h-2.524V91.538H402.8V83.913Z",
    transform: "translate(-354.467 -82.283)",
    fill: "#2f80c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M453.964,116.251l-12.885.053c.052,1.315.052,4.418.263,5.679.105.842.368,3.208,3.155,3.208,3.1,0,3.1-3.208,3.156-5.417h6.206a24.015,24.015,0,0,1-.158,2.787c-.526,3.945-2.261,5.47-3.892,6.311a11.172,11.172,0,0,1-5.259,1.157c-1.157,0-6.311.053-8.572-4.1-1.209-2.261-1.525-5.364-1.525-10.728a54.44,54.44,0,0,1,.263-5.89c.315-3.26,1.157-4.786,2.208-5.943,1.263-1.42,3.419-2.787,7.626-2.787,4.523,0,6.627,1.525,7.784,3.313,1.63,2.524,1.63,6,1.63,8.783Zm-6.364-4.523v-.894a14.808,14.808,0,0,0-.052-1.525c0-.684.105-3.892-3.05-3.892a2.857,2.857,0,0,0-2.367.894c-1.052,1.1-1.1,2.577-1.1,5.417Z",
    transform: "translate(-374.655 -92.112)",
    fill: "#2f80c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M501.3,109.993a11.466,11.466,0,0,0-.052-1.368c-.053-.841-.263-3.313-3.1-3.313a3.033,3.033,0,0,0-1.209.21,2.392,2.392,0,0,0-1.525,2.314,2.786,2.786,0,0,0,.368,1.368c.579,1.209,2.419,2.262,3.471,2.945.894.578,1.789,1.21,2.735,1.841a28.206,28.206,0,0,1,2.525,1.841,7.828,7.828,0,0,1,3,6.311,10.617,10.617,0,0,1-.473,3.05c-1.736,5.1-7.836,4.891-8.941,4.891-4.313,0-6.364-1.42-7.52-3.1-1.631-2.367-1.578-5-1.525-7.731h5.838c0,.736,0,1.42.053,2.156.053.894,0,3.944,3.366,3.944a2.6,2.6,0,0,0,2.892-2.682c0-1.946-1.683-2.787-3-3.629-.736-.526-1.525-1-2.262-1.525a24.6,24.6,0,0,1-4.523-3.576,7.491,7.491,0,0,1-2.1-5.574,8.542,8.542,0,0,1,.631-3.366c1-2.367,3.313-4.418,8.625-4.418a13.258,13.258,0,0,1,3.418.473,6.418,6.418,0,0,1,4.681,4.576,15.394,15.394,0,0,1,.42,4.365Z",
    transform: "translate(-406.84 -92.112)",
    fill: "#2f80c2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d8e77e8f8ed46a33db7900c4a12ac445.svg";
export { ForwardRef as ReactComponent };